export default __webpack_public_path__ + "static/media/Samson-Lee.2e825d9d.jpg";